import script from "./ForceEmailVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./ForceEmailVerification.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__